import React, { useCallback } from 'react';
import { UserAccountLink } from './UserAccountMenu';
import css from './UserAccountMenu.module.scss';
import { Link } from '@framework-controls/core';
import { CustMode } from 'src/enums';
import classNames from 'classnames';

export interface IProps {
    id: string;
    header: string;
    theme: string;
    links: UserAccountLink[];
    clickHandler: (componentId: string, label: string, custModeType: CustMode, linkId: string) => void;
}

const UserAccountPanel = (props: IProps) => {
    const displayLinks: React.ReactElement[] = [];

    let linkClassName = css.linkButton;
    if (props.theme === 'colorSensitive') {
        linkClassName = css.linkButtonADA;
    } else if (props.theme === 'lexus') {
        linkClassName = classNames (
            css.linkButton, css.linkButtonADA,
        );
    }

    const clickHandler = useCallback((componentId: string, label: string, custModeType: CustMode, linkId: string) => {
        props.clickHandler(componentId, label, custModeType, linkId);
    }, [props.clickHandler]);

    // if the user pressed Enter (32) or spacebar (13) when focus is on a link
    // then we want to act as if they had done a mouse click on the link.
    const keyFunction = useCallback((e, componentId: string, label: string, custModeType: CustMode, linkId: string) => {
        if (e.keyCode === 32 || e.keyCode === 13) {
            props.clickHandler(componentId, label, custModeType, linkId);
        }
    }, [props.clickHandler]);

    // for each item in the link array build the link to the screen.
    props.links.forEach((link, index) => {
        if (!link.hide) {
            const displaylink: React.ReactElement = (
                <span className={css.linkSpan} key={index}>
                    <span className={css.linkLink} id={'Span' + link.id} key={index} tabIndex={0} onKeyDown={(e) => keyFunction(
                        e, link.componentId, link.label, link.custModeType, link.id)}>
                        <Link className={linkClassName} key={link.id} id={link.id} onClick={() => clickHandler(
                            link.componentId, link.label, link.custModeType, link.id)} disabled={link.disabled}>{link.label}</Link>
                    </span>
                    <span className={css.linkSpace}>
                    </span>
                </span>
            );
            displayLinks.push(displaylink);
        }
    });

    return (
        <div className={css.linkRow}>
            <hr className={css.headerHR}/>
            <h3 className={css.header}>{props.header}</h3>
            <hr className={css.headerHRB}/>
            {displayLinks}
        </div>
    );
};

export default UserAccountPanel;